<div class="item-group-select-wrapper">
  <div
    [id]="triggerId || null"
    class="item-group-select-trigger"
    (click)="openPanel()"
  >
    <app-input-text
      #searchInput
      [bare]="true"
      [plain]="true"
      [inputId]="triggerInputId"
      cssClass="item-group-trigger-input booking-dropdown-trigger-value"
      [value]="searchTerm"
      [placeholder]="placeholder"
      (focusEvent)="openPanel()"
      (inputEvent)="onSearchInput($event)"
      (keydownEvent)="onSearchKeydown($event)"
    ></app-input-text>
    <i
      [id]="arrowId || null"
      class="fas fa-chevron-down item-group-trigger-arrow"
    ></i>
  </div>
  <mat-select
    #overlaySelect
    [id]="inputId || null"
    class="item-group-select item-group-select-overlay"
    [panelClass]="panelClass"
    [value]="selectedValues"
    multiple
    (selectionChange)="onSelectionChange($event.value)"
    (opened)="onOpened()"
    (closed)="onClosed()"
  >
    <mat-option
      *ngFor="let option of filteredOptions; trackBy: trackByValue"
      [value]="optValue(option)"
    >
      <div
        class="item-group-option-content"
        [class.is-selected]="isSelected(optValue(option))"
      >
        <div class="item-group-option-copy">
          <span class="item-group-option-name">{{ optLabel(option) }}</span>
        </div>
        <i
          class="fas item-group-option-icon"
          [ngClass]="isSelected(optValue(option)) ? 'fa-minus' : 'fa-plus'"
          aria-hidden="true"
        ></i>
      </div>
    </mat-option>
    <mat-option *ngIf="noResults" disabled class="item-group-no-results-option">
      {{ noResultsLabel | translate }}
    </mat-option>
  </mat-select>
</div>
